/**
 * Limits concurrent image decodes so the main thread isn't flooded when many
 * hex tiles load at once (decode is CPU-heavy).
 */

const MAX_CONCURRENT_DECODES = 3;
let active = 0;
const queue: Array<() => void> = [];

function tryStartNext(): void {
  if (active < MAX_CONCURRENT_DECODES && queue.length > 0) {
    active++;
    const next = queue.shift()!;
    next();
  }
}

export function acquireDecodeSlot(): Promise<void> {
  if (active < MAX_CONCURRENT_DECODES) {
    active++;
    return Promise.resolve();
  }
  return new Promise<void>((resolve) => {
    queue.push(() => resolve());
  });
}

export function releaseDecodeSlot(): void {
  active--;
  tryStartNext();
}
